import React, { useState, useEffect } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import headerImage from "../../../../../assets/img/longarrow.jpg";
import GradientButton from "components/Buttons/GradientButton.js";
import ReusableInput from "components/Inputs/ReusableInput.js";
import { formatDate } from "utils/dateFormatter";

const EditFAQDrawer = ({ isOpen, onClose, faq, onUpdateFAQ }) => {
  const [formData, setFormData] = useState(faq);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    // Update formData whenever the faq prop changes
    setFormData(faq);
  }, [faq]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleToggleEdit = () => {
    if (isEditing) {
      // Save changes when in editing mode
      onUpdateFAQ(formData);
      setIsEditing(false);
    } else {
      // Enable editing mode
      setIsEditing(true);
    }
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerImage={headerImage}
      headerContent={<h2>{isEditing ? "Edit FAQ" : "View FAQ"}</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Question"
            name="question"
            value={formData?.question || ""}
            onChange={handleInputChange}
            placeholder="Enter the FAQ question"
            type="textarea"
            isReadOnly={!isEditing} 
          />
          <ReusableInput
            label="Answer"
            name="answer"
            value={formData?.answer || ""}
            onChange={handleInputChange}
            placeholder="Enter the FAQ answer"
            type="textarea"
            isReadOnly={!isEditing} 
          />
          <ReusableInput
            label="Date Added"
            name="dateAdded"
            value={formatDate(formData?.created_at) || ""}
            isReadOnly  // Keep date read-only
            placeholder="Auto-generated"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} fontSize="15px" width="100px" height="40px">
            Cancel
          </GradientButton>
          <GradientButton onClick={handleToggleEdit} fontSize="15px" width="100px" height="40px">
            {isEditing ? "Save" : "Edit"}  
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default EditFAQDrawer;
